module.exports = __webpack_public_path__ + "static/media/0036.2e61be6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48010/Chassis_RAL/0036.png
// module id = 402
// module chunks = 0